export type LocalGameMode =
    | "normal"
    | "wasd"
    | "snake"
    | "colorrush"
    | "counter"
    | "heat"
    | "speedrun"
    | "highway"
    | "sandbox"
    | "soccer";

export const LOCAL_GAME_MODES: LocalGameMode[] = [
    "normal",
    "wasd",
    "snake",
    "colorrush",
    "counter",
    "heat",
    "speedrun",
    "highway",
    "sandbox",
    "soccer",
];

export const LOCAL_COOP_MODES: LocalGameMode[] = ["speedrun", "counter", "colorrush"];

export type LocalPlayerSlot = {
    name: string;
    color: string;
};

export type LocalConfig = {
    playerCount: 2 | 3 | 4;
    showUsernames: boolean;
    showDivisions: boolean;
    useJoystick: boolean;
    players: LocalPlayerSlot[];
    mode: LocalGameMode;
    speedrunLevel: number;
    colorRushBallCount: number;
};

export type LocalZoneRect = {
    x: number;
    y: number;
    w: number;
    h: number;
    cx: number;
    cy: number;
};

export type LocalPlayerState = {
    index: number;
    name: string;
    color: string;
    x: number;
    y: number;
    prevX: number;
    prevY: number;
    alive: boolean;
    zone: LocalZoneRect;
    heatLevel: number;
    wasdKeys: { w: boolean; a: boolean; s: boolean; d: boolean };
};

export const LOCAL_DEFAULT_COLORS = ["#00ffff", "#ff66ff", "#ffff66", "#66ff66"];

export const LOCAL_DEFAULT_NAMES = ["P1", "P2", "P3", "P4"];
